<div class="app-sidebar colored">
  <div class="sidebar-header">
    <a class="header-brand" routerLink="/landind" style="cursor: pointer">
      <div class="logo-img">
        <!-- <img src="assets/images/avatar.png" class="header-brand-img" alt="SEU">  -->
        <!-- <img class="avatar" src="assets/images/logo.png" alt=""> -->
        <img src="assets/images/new-logo.png" class="avatar" />
      </div>
      <!-- <span class="text">SEU Accreditation</span> -->
    </a>

    <!--Employee Dependent-->
    <!--  <div class="dropdown" *ngIf="this.global.Role == 'EmployeePatient'">

      <a class="dropdown-toggle" href="javascript:void(0);" id="employeeDependants" role="button"
        data-toggle="dropdown">
        <i class="ik ik-chevron-down"></i> <span style="font-size: 14px">{{selectedDependant}}</span> </a>
      <div class="dropdown-menu user-drop" aria-labelledby="userRolesDropdown">
        <a class="dropdown-item" href="javascript:void(0);"
          (click)="ChooseDependant(loginUserId,loginUserName,loginPatientId)"> {{loginUserName}}</a>
        <ng-container *ngFor="let dep of empDependants">
          <a class="dropdown-item" href="javascript:void(0);"
            (click)="ChooseDependant(dep.dependentUserId,dep.userName,dep.patientId)"> {{dep.userName}}</a>
        </ng-container>

      </div>
    </div> -->

    <!-- <div class="dropdown" *ngIf="this.global.Role != 'EmployeePatient'">
      <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">

         <span style="font-size: 14px"> {{global.FirstName }} {{global.LastName}} </span>

       </a>


     </div>  -->

    <button type="button" class="nav-toggle nav-tg" data-toggle="expanded">
      <!-- <i data-toggle="expanded" class="fas fa-bars toggle-icon"></i> -->
      <img
        src="assets/images/icons/menu-bars.svg"
        data-toggle="expanded"
        class="toggle-icon"
        alt="menu bars icon"
        style="width: 20px"
      />
    </button>
    <button id="sidebarClose" class="nav-close"><i class="ik ik-x"></i></button>
  </div>

  <div class="sidebar-content" id="style-1">
    <!-- Here you can view any menu according to user role -->

    <app-admin-menu *ngIf="global.Role == 'Admin'"></app-admin-menu>
    <app-supervisor-menu
      *ngIf="global.Role == 'Supervisor'"
    ></app-supervisor-menu>
    <app-specialist-menu
      *ngIf="global.Role == 'SPECIALIST'"
    ></app-specialist-menu>
    <app-patient-menu *ngIf="global.Role == 'PATIENT'"></app-patient-menu>

    <!--     <app-content-admin-menu *ngIf="global.Role=='ContentAdmin'"></app-content-admin-menu>
 -->
  </div>
</div>
